export default __webpack_public_path__ + "static/istio-addons-245f01d54b7828cba95ca381e23b9ddc.webp";